import { useMutation } from "@tanstack/react-query";
import { setNotificationTokenService } from "../services/notification-service";


export const useSetNotificationTokenMutation = () => {
    const mutateFn = async (payload: any) => {
        const res = await setNotificationTokenService(payload);
        return res;
    };

    return useMutation({
        mutationFn: mutateFn,
    });
};